export const ENDPOINT_URL =
  'https://cf-assignment-ryytohruuyd.maowtm.workers.dev'
